import PrimaryCell from "../../../../../ui/Table/Cells/PrimaryCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "number",
    cellRender: PrimaryCell,
    width: 75
  },
  {
    dataField: "referenceTypeName",
    caption: "Вид ресурса",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "name",
    caption: "Название",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "location",
    caption: "Расположение",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "author",
    caption: "Автор/составитель",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "year",
    caption: "Год",
    dataType: "string",
    cellRender: PrimaryCell
  }
];
